import {Component, input, viewChild} from "@angular/core";
import {Translations} from "@translations";
import {AssessmentState, UserRecordingAssessment} from "@models";
import {AssessablePanelMode, AssessablePanelType} from "@common/components/assessment/utils";
import {AssessmentAnswerSingleItemPanelComponent} from "../assessable-panels/assessment-answer-single-item-panel/assessment-answer-single-item-panel.component";

@Component({
	selector: "sim-participant-device-student-assessment-display",
	templateUrl: "./participant-device-student-assessment-display.component.html",
	styleUrl: "./participant-device-student-assessment-display.component.scss",
	standalone: false,
})
export class ParticipantDeviceStudentAssessmentDisplayComponent {
	protected readonly T = Translations;
	protected readonly AssessablePanelMode = AssessablePanelMode;
	protected readonly AssessablePanelType = AssessablePanelType;
	protected readonly AssessmentState = AssessmentState;

	public readonly assessment = input.required<UserRecordingAssessment>();

	public readonly assessmentPanel = viewChild.required(AssessmentAnswerSingleItemPanelComponent);

	public handleIndexItemClick({itemId}: {groupId: string; itemId: string}) {
		this.assessmentPanel().moveToItem(itemId);
	}
}
